<script setup lang="ts">
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge'

definePage({
  path: '/auth/redirect',
  name: 'auth.redirect',
  meta: {
    layout: 'empty',
    isAuthRedirect: true,
    allowAnonymous: true,
  },
})

/*
 * MSAL v5 requires this redirectUri page to relay the auth response back to the main frame when
 * it's loaded inside a popup/hidden iframe (used by silent/COOP-isolated flows). Without it,
 * acquireTokenSilent's iframe fallback times out with BrowserAuthError "timed_out"
 * (redirect_bridge_timeout) instead of resolving or throwing InteractionRequiredAuthError.
 */
broadcastResponseToMainFrame().catch(console.error)
</script>

<template>
  <div />
</template>